module.exports = __webpack_public_path__ + "img/slider_3.dc805fd6.jpg";